import { lazy, useMemo } from 'react'
import { FlyoutTabs } from './FlyOut'
import { FlyoutCloudSettingsWrapper } from '../FlyoutCloudSettingsWrapper'

export const FlyOutWrapper = () => {
  const cloudSettingsTab = useMemo(
    () => [
      {
        key: 'cloud-settings',
        product: 'flyout',
        label: 'Cloud settings',
        path: 'cloud',
        component: lazy(() => import('./CloudSettingsRoute')),
        childRoutes: [
          {
            key: 'aws',
            label: 'AWS',
            path: 'aws',
            component: FlyoutCloudSettingsWrapper,
          },
        ],
      },
    ],
    []
  )

  return <FlyoutTabs additionalTabs={cloudSettingsTab} />
}

export default FlyOutWrapper
